import { fromJS, Map, List } from 'immutable';
import config from '../../../config';
import actions from '../../constants/portal/news';
import history from '../../../history';
import {checkJsonResponse, logErrorConsole, generateAuthorizationOption} from 'utils/actions';


export const newsAreLoading = (data) => ({
  type: actions.NEWS_ARE_LOADING,
  data
})

export const newIsSubmitting = data => ({
  type: actions.NEW_IS_SUBMITTING,
  data
});

export const loadNews = (limit=25, offset=0, tag) => (dispatch) => {
  dispatch(newsAreLoading(true));
  fetch(`${config.apiHost}/news/?limit=${limit}&offset=${offset}&tag=${tag}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_NEWS,
      data
    });
    dispatch(newsAreLoading(false))
  })
  .catch(logErrorConsole)
};
 
export const searchNews = (name, start_date, end_date, tag, current_status="public", limit, offset) => (dispatch) => {
  const date_start = start_date.format("YYYY-MM-DDTHH:mm:ss");
  const date_end = end_date.format("YYYY-MM-DDT23:59:59");
  dispatch(newsAreLoading(true));
  fetch(`${config.apiHost}/news/?search=${name}&date_published__range=${date_start}Z,${date_end}Z&tag=${tag}&current_status=${current_status}&limit=${limit}&offset=${offset}`)
  .then(checkJsonResponse)
  .then((json) => {
    dispatch(newsAreLoading(false))
    dispatch({
      type: actions.LOAD_NEWS,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
  .then(() => {
    dispatch(newsAreLoading(false));
  })
};

////////////////News in admin panel

export const newsAdminAreLoading = (data) => ({
  type: actions.NEWS_ADMIN_ARE_LOADING,
  data
})


export const searchNewsAdmin = (name, start_date, end_date, tag, current_status="", limit, offset) => (dispatch, getState) => {
  const date_start = start_date.format("YYYY-MM-DDTHH:mm:ss");
  const date_end = end_date.format("YYYY-MM-DDT23:59:59");
  dispatch(newsAdminAreLoading(true));
  fetch(`${config.apiHost}/news/?search=${name}&date_published__range=${date_start}Z,${date_end}Z&tag=${tag}&current_status=${current_status}&limit=${limit}&offset=${offset}`, generateAuthorizationOption(getState))
  .then(checkJsonResponse)
  .then((json) => {
    dispatch(newsAreLoading(false))
    dispatch({
      type: actions.LOAD_ADMIN_NEWS,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
  .then(() => {
    dispatch(newsAdminAreLoading(false));
  })
};



export const searchNewsByTag = (tag, limit, offset) => (dispatch, getState) => {
  dispatch(newsAreLoading(true));
  fetch(`${config.apiHost}/news/?tag=${tag}&limit=${limit}&offset=${offset}`)
  .then(checkJsonResponse)
  .then((json) => {
    dispatch(newsAreLoading(false))
    dispatch({
      type: actions.LOAD_NEWS,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
};



export const loadNewsDetail = (id) => (dispatch, getState) => {
  dispatch(newsAreLoading(true));
  fetch(`${config.apiHost}/news/${id}/`, generateAuthorizationOption(getState))
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_NEWS_DETAIL,
      data
    });
    
  })
  .catch(logErrorConsole)
  .then (() => {
    dispatch(newsAreLoading(false))
  })
};


export const changeNewsItemValue = (data, key) => ({
	type: actions.SET_NEWS_ITEM_VALUE,
	key,
	data
});


export const addTitleImageToNews = (data) => (dispatch) => {
  dispatch({
    type: actions.ADD_TITLE_IMAGE_TO_NEWS,
    data: data
  });
};


export const addFileForm = (data) => ({
  type: actions.ADD_FILE_FORM,
  data
})


export const attachFileToNews = data => dispatch => {
  if (data.files.length < 1) {
    return;
  }
  let fileList = [];
  for (let i=0; i<data.files.length; i++) {
    fileList[i] = data.files[i];
  }
  dispatch({
    type: actions.ADD_FILES_TO_NEWS,
    data: fileList
  });
};

export const deleteImage = (id, news_id) => (dispatch, getState) => {
  const options = {
    method: "delete",
    headers: {
       "Authorization": "Token " + getState().auth.get('token'),
    }
  };

  fetch(`${config.apiHost}/content/${id}/`, options)
  .then(response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return null;
  })
  .then(() => {
    history.push(`/admin/news/detail/${news_id}`);
    dispatch(loadContentByNews(news_id))
  })
  .catch(e => {
    console.log(e);
  })
}

export const submitFilesToNews = (news_id) => (dispatch, getState) => {
  dispatch(newIsSubmitting(true))
	const files = getState().news.get('attachedFiles');
	const file = files.map((item, i) => {
		let method = 'post';
    const formData = new FormData();
    formData.append('file', item);
    formData.append('name', item.name);
    formData.append('news', news_id);
	  const options = {
	    method,
	    headers: {
	      "Authorization": "Token " + getState().auth.get('token'),
	    },

	    body: formData
	  }
		return fetch(`${config.apiHost}/content/`, options)
		.then(checkJsonResponse)
		.catch(logErrorConsole)
  });
  
	return Promise.all(file)
	.then(json => {
	})
	.catch(logErrorConsole)
}

//////////////////////content is loading

export const contentByNewsIsLoading = (data) => ({
  type: actions.CONTENT_BY_NEWS_IS_LOADING,
  data
})

export const loadContentByNews = id => (dispatch) => {
  dispatch(contentByNewsIsLoading(true));
  fetch(`${config.apiHost}/content/?news=${id}`)
  .then(checkJsonResponse)
  .then((json) => {
    dispatch({
      type: actions.LOAD_NEWS_CONTENT,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
  .then(() => {
    dispatch(contentByNewsIsLoading(false));
  })
}

export const submitNews = (id, author_id, tag_id, current_status) => (dispatch, getState) => {
  let method = id ? 'PATCH' : 'POST';
  const formData = new FormData();
  formData.append('brief_description', getState().news.get('newsDetail').get('brief_description'));
  formData.append('detail_description', getState().news.get('newsDetail').get('detail_description'));
  formData.append('title', getState().news.get('newsDetail').get('title'));
  formData.append('author', author_id);
  formData.append('current_status', current_status);

  const image = getState().news.get('newsDetail').get('image');

  let path = id ? `${config.apiHost}/news/${id}/` : `${config.apiHost}/news/`;

  let options

  if (!image){
    options = {
      method,
      headers: {
        "Authorization": "Token " + getState().auth.get('token'),
        "Content-type": 'application/json'
      },
      body: JSON.stringify({
        brief_description: getState().news.get('newsDetail').get('brief_description'),
        detail_description: getState().news.get('newsDetail').get('detail_description'),
        title: getState().news.get('newsDetail').get('title'),
        author: author_id,
        current_status: current_status,
        image: null
      })
    }
  } else if (typeof image === 'string') {
    options = {
      method,
      headers: {
        "Authorization": "Token " + getState().auth.get('token'),
        "Content-type": 'application/json'
      },
      body: JSON.stringify({
        brief_description: getState().news.get('newsDetail').get('brief_description'),
        detail_description: getState().news.get('newsDetail').get('detail_description'),
        title: getState().news.get('newsDetail').get('title'),
        author: author_id,
        current_status: current_status,
      })
    }
  } else {
    dispatch(newIsSubmitting(true))
    formData.append('image', image)
    options = {
      method,
      headers: {
        "Authorization": "Token " + getState().auth.get('token'),
      },
      body: formData
    } 
  }

  fetch(path, options)
  .then(checkJsonResponse)
  .then((json) => {
   const promise1 = dispatch(submitFilesToNews(json.id))
   const promise2 =  dispatch(addTagToNews(json.id, tag_id))
   Promise.all([promise1, promise2])
     .then(()=> {
       dispatch(newIsSubmitting(false))
       history.push(`/admin/news/detail/${json.id}`)
     })
  })
  .catch(() => dispatch(newIsSubmitting(false)))
};


export const allNewsTagsAreLoading = (data) => ({
  type: actions.ALL_NEWS_TAGS_ARE_LOADING,
  data
})

export const loadNewsTags = () => (dispatch) => {
  dispatch(allNewsTagsAreLoading(true))
  fetch(`${config.apiHost}/tag/`)
  .then(checkJsonResponse)
  .then((json) => {
    dispatch({
      type: actions.LOAD_NEWS_TAGS,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
  .then(() => {
    dispatch(allNewsTagsAreLoading(false))
  })
};

export const addTagToNews = (news_id, tag_id) => (dispatch, getState) => {
  const id = getState().news.getIn(['tagsByNews','results', 0, 'id']);
  const method = id ? 'PATCH' : 'POST';
  

  let path = id ? `${config.apiHost}/news_tag/${id}/` : `${config.apiHost}/news_tag/`;
  const options = {
    method, 
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
      "Content-type": 'application/json'
    },
    body: JSON.stringify({
      news: news_id,
      tag: tag_id
    })
  }
  return fetch(path, options)
  .then(checkJsonResponse)
  .then((json) => {

  })
  .catch(logErrorConsole)
}


export const tagsByNewsAreLoading = (data) => ({
  type: actions.TAGS_BY_NEWS_ARE_LOADING,
  data
})

export const loadTagsByNews = (id) => (dispatch) => {
  dispatch(tagsByNewsAreLoading(true))
  fetch(`${config.apiHost}/news_tag/?news=${id}`)
  .then(checkJsonResponse)
  .then((json) => {
    dispatch({
      type: actions.LOAD_NEWS_TAGS,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
  .then(()=>{
    dispatch(tagsByNewsAreLoading(false))
  })
}

export const loadTagsByNewsDetail = (id) => (dispatch) => {
  dispatch(tagsByNewsAreLoading(true));
  fetch(`${config.apiHost}/news_tag/?news=${id}`)
  .then(checkJsonResponse)
  .then((json) => {
    dispatch({
      type: actions.LOAD_TAGS_BY_NEWS,
      data: fromJS(json)
    })
  })
  .catch(logErrorConsole)
  .then(() => {
    dispatch(tagsByNewsAreLoading(false));
  })
}

//for adminPanel

export const changeNewsValue = (data, key) => ({
	type: actions.SET_NEWS_ITEM_VALUE,
	key,
	data
});

export const changeNewsStatus = (id) => (dispatch, getState) => {
    const formData = new FormData();
    formData.append('current_status', getState().news.get('newsDetail').get('current_status'));
    const options = {
      method: 'PATCH',
      headers: {
        "Authorization": "Token " + getState().auth.get('token'),
      },
      body: formData,
    }
    fetch(`${config.apiHost}/news/${id}/proceed/`, options)
    .then(checkJsonResponse)
    .then((json) => {
  
      })
    .then(logErrorConsole)
  }

  export const deleteNews = (id) => (dispatch, getState) => {
    const options = {
      method: "delete",
      headers: {
         "Authorization": "Token " + getState().auth.get('token'),
      }
    };
  
    fetch(`${config.apiHost}/news/${id}/`, options)
    .then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return null;
    })
    .then(() => {
      history.push(`/admin/news`);
    })
    .catch(e => {
      console.log(e);
    })
  }

  export const changeNewsAreLoading = (data=true) => ({
    type: actions.NEWS_ARE_LOADING,
    data
  });

  export const newsCleanFiles = (data=true) => ({
    type: actions.ADD_FILES_TO_NEWS,
    data: new List([])
  })

  export const newsCleanTag = (data=true) => ({
    type: actions.LOAD_NEWS_TAGS,
    data: new Map()
  })

  export const newsCleanStore = () => (dispatch) => {
    dispatch({
      type: actions.LOAD_NEWS_DETAIL,
      data: new Map({
        brief_description: '',
        detail_description: '',
        title: '', 
        image: undefined,
        current_status: ''
      })
    });
    dispatch(changeNewsAreLoading(false));
  
  }





// WEBPACK FOOTER //
// ./src/redux/actions/portal/news.js